export default "/_next/static/images/dragana-mijalkovic-8b113b6cc519204f8619e74ad62f3d3a.png";